import * as React from 'react';

import blackLogo from '~/assets/images/branding/numa_icon_black.svg';
import whiteLogo from '~/assets/images/branding/numa_icon_white.svg';
import blackName from '~/assets/images/branding/numa_name_black.svg';
import whiteName from '~/assets/images/branding/numa_name_white.svg';

import { BaseComponentProps } from './types';

type LogoColor = 'primary' | 'contrast';
type LogoType = 'word' | 'icon';

export interface LogoProps
  extends BaseComponentProps,
    Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  type: LogoType;
  color: LogoColor;
}

export const Logo = ({ type, color, ...otherProps }: LogoProps) => {
  let imgSrc;
  if (type === 'icon') {
    imgSrc = color === 'primary' ? blackLogo : whiteLogo;
  } else {
    imgSrc = color === 'primary' ? blackName : whiteName;
  }
  return <img src={imgSrc} alt="Numa" {...otherProps} />;
};
